import { c as a } from "./index-Di82Y7n3.js";
const e = a("text-inherit bg-gray-300", {
  variants: {
    size: {
      default: "size-10",
      full: "size-full"
    },
    accent: {
      primary: "bg-primary text-primary-foreground",
      secondary: "bg-secondary text-secondary-foreground"
    }
  },
  defaultVariants: {
    size: "default",
    accent: "secondary"
  }
});
export {
  e as a
};
